import {PaletteOptions} from '@material-ui/core/styles/createPalette';
import {alpha} from '@material-ui/core/styles/colorManipulator';
import {common} from '@material-ui/core/colors';

const offBlack = '#141414';

export const darkColors: PaletteOptions = {
    background: {
        default: offBlack,
        paper: '#272727',
        // @ts-ignore
        overlays: '#3A3A3A'
    },
    secondary: {
        main: '#3A3A3A'
    },
    divider: alpha(common.white, 0.16),
    dividerStrong: alpha(common.white, 0.32),
    action: {
        active: alpha(common.white, 0.24),
        hover: alpha(common.white, 0.16),
        focus: alpha(common.white, 0.16),
        selected: alpha(common.white, 0.08)
    }
};
